const English = {
  allApplications: "All Applications",
  allPartners: "All Partners",
  dmsmap: "DMS Mapping",
  documentsCode: "Document Codes",
  applicationNo:"Application No.",
  applications: "Applications",
  applicationDetail:"Application Details",
  applicationNos:"Application No's",
  partnerDetails:"Partner Details",
  partnerName:"Partner Name",
  partnerCode:"Partner Code",
  crmStatus:"CRM Completion Status",
  fusionStatus:"Fusion Completion Status",
  webhookStatus:"Web Hook Status",
  pennantStatus:"Pennant Completion Status",
  status:"Status",
  statusDetails:"Status Details",
  branch:"Branch",
  branchManagement:"Branch Management",
  branchName: "Partner branch name",
  changePassword: "Change Password",
  clearAll: "Clear All",
  continue: "Continue",
  continueJourney:"Continue Journey",
  createBranch: "Create Branch",
  createdBy: "Created By",
  createdDate: "Created Date",
  createLead:"Create Lead",
  createUser:"Create User",
  crm:"CRM",
  currentPassword: "Current Password",
  currentStatus: "Current status",
  dashboard:"Dashboard",
  digitalAlliance:"Digital Alliance",
  fusion:"Fusion",
  systemDate:"System Date",
  editDetails: "Edit Details",
  email:"User Email",
  emailAddress:"E-mail Address",
  exitApp: "Are you sure want to exit from App?",
  filters: "Filters",
  hi: "Hi",
  label:{
  leads: "Applications"
  },
  leadDetails:"Lead Details",
  loanAmount: "Loan amount",
  loanProduct:"Loan Product:EL",
  location:"Location",
  login:"Login",
  logOut: "Logout",
  mobileNumber:"Mobile Number",
  myLead:"Lead Management",
  name: "Name",
  needHelp: " Need Help?",
  roleManagement: "Role Management",
  addRole: "Add Role",
  userManagement: "User Management",
  addUser: "Add User",
  name: "Name",
  next: "Next",
  noDataFound:"No Data Found",
  orLoginWith: "Or Login with",
  partnerExecutive:"Partner Executive",
  password: "Password",
  passwordRequired: "Password Required",
  partners:"Partners",
  documentCodes:"Document Codes",
  dmsMapping:"DMS Mapping",
  eSign: "E Sign",
  eMudra: "E Mudra",
  paymentLog: "Payment Log",
  inputRequest:"Input Request",
  utr: "UTR",
  notification: "Notification",
  paymentProcess: "Payment Process",
  paymentReceipt: "Payment Receipt",
  partners:"Partners",
  partnerSystem:"Web Hook Status",
  pennant:"LMS ( Pennant )",
  documents:"Documents",
  tpRequestResponse:"TP Request",
  placeholders: {
    course: "Course",
    courseType: "Course Type",
    avanseBranch: "Avanse Branch",
    kycStatus: "KYC Status",
    pennantStatus: "Pennant Completion Status",
    webhookStatus: "Web Hook Status",
    fusionStatus: "Fusion Status",
    crmStatus: "CRM Completion Status",
    sNo: "S.No.",
    applicantName: "Applicant Name",
    createdDate: "Created Date",
    partnerBranch: "Partner Branch",
    role: "Role",
    userName: "User Name",
    apiName: "Api Name",
  },
  saveChanges: "Save Changes",
  selected: "Select",
  signIn:"Sign In",
  signInToContinue: "Sign in to continue with your account",
  sno: "S No.",
  sortBy: "Sort By",
  spoc:"SPOC",
  status: "Status",
  studentName:"Student Name",
  submit:"Submit",
  userDetails: "User Details",
  userName: "User Name",
  users:"Users",
  validEmail: "Enter Valid Email Address",
  validUsername: "Enter valid Username or Email",
  validPassword: "Enter Valid Password",
  viewDetails:"View Details",
  viewProfile: "View Profile",
  welcome: "Welcome",
  welcomeMessage: "Welcome to your dashboard and now you can manage your leads here.",
  fusionApplicationNumber:"Fusion Application Number",
  digitalAllianceApplicationNumber:"Digital Alliance Application Number",
  partnerApplicationNumber:"Partner Application Number",
  applicationStatus:"Application Status",
  };
  
  export default English;
  
  